import { createSlice } from "@reduxjs/toolkit";
import { SalesNoteFormDetailType, FormFieldType, NoteType } from "./Types";

type initialStateType = {
  formFieldsSalesNote: FormFieldType[];
  salesNoteFormDetail: SalesNoteFormDetailType | null;
  notesList: NoteType[];
  status: {
    formFieldsSalesNoteLoading: boolean;
    addFormSalesNoteLoading: boolean;
    addFormSalesNoteStatus: boolean;
    addFormSalesNoteMessage: string;
    salesNoteFormDetailLoading: boolean;
    notesListLoading: boolean;
    addNoteLoading: boolean;
    updateNoteLoading: boolean;
    deleteNoteLoading: boolean;
  };
};

const initialState: initialStateType = {
  formFieldsSalesNote: [],
  salesNoteFormDetail: null,
  notesList: [],
  status: {
    formFieldsSalesNoteLoading: false,
    addFormSalesNoteLoading: false,
    addFormSalesNoteStatus: false,
    addFormSalesNoteMessage: "",
    salesNoteFormDetailLoading: false,
    notesListLoading: false,
    addNoteLoading: false,
    updateNoteLoading: false,
    deleteNoteLoading: false,
  },
};

const notesSlice = createSlice({
  name: "notes",
  initialState: initialState,
  reducers: {
    setFormFieldsSalesNote: (state, action) => {
      state.formFieldsSalesNote = action.payload;
    },
    setFormFieldsSalesNoteLoading: (state, action) => {
      state.status.formFieldsSalesNoteLoading = action.payload;
    },
    setAddFormSalesNoteLoading: (state, action) => {
      state.status.addFormSalesNoteLoading = action.payload;
    },
    setAddFormSalesNoteStatus: (state, action) => {
      state.status.addFormSalesNoteStatus = action.payload;
    },
    setAddFormSalesNoteMessage: (state, action) => {
      state.status.addFormSalesNoteMessage = action.payload;
    },
    setSalesNoteFormDetail: (state, action) => {
      state.salesNoteFormDetail = action.payload;
    },
    setSalesNoteFormDetailLoading: (state, action) => {
      state.status.salesNoteFormDetailLoading = action.payload;
    },
    setNotesList: (state, action) => {
      state.notesList = action.payload;
    },
    setNotesListLoading: (state, action) => {
      state.status.notesListLoading = action.payload;
    },
    setAddNoteLoading: (state, action) => {
      state.status.addNoteLoading = action.payload;
    },
    setUpdatedNote: (state, action) => {
      const index = state.notesList.findIndex(
        (note) => note.ID === action.payload.ID
      );
      if (index !== -1) {
        state.notesList[index] = action.payload;
      }
    },
    setUpdateNoteLoading: (state, action) => {
      state.status.updateNoteLoading = action.payload;
    },
    setDeletedNote: (state, action) => {
      state.notesList = state.notesList.filter(
        (note) => note.ID !== action.payload
      );
    },
    setDeleteNoteLoading: (state, action) => {
      state.status.deleteNoteLoading = action.payload;
    },
  },
});

export const notesSliceReducer = notesSlice.reducer;
export const notesSliceAction = notesSlice.actions;
